<template>
  <div>
    <van-dialog v-model="DialogShow" title="添加合同信息" width="95%" style="height:80%" class="editClue"  :beforeClose="beforeClose" show-cancel-button>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field v-model="form.contractName" label="合同标题" placeholder="请输入合同标题" :rules="[{ required: true }]" required />
          <van-field v-model="form.contractNum" label="合同编号" placeholder="请输入合同编号" :rules="[{ required: true}]" required />
          <van-field readonly clickable v-model="form.boName" placeholder="请选择商机名称" @click="showPicker('boId')" label="商机名称" required />
          <van-field v-model="form.custName" label="客户名称" placeholder="请选择商机名称" :rules="[{ required: true }]" readonly required />
          <van-field v-model="form.contractMoney" label="合同金额(元)" placeholder="请输入合同金额" @input="getSum" :rules="[{ required: true }]" type="number" maxlength="15" required />
          <van-field v-model="form.allReturnedMoney" label="合同回款总金额(元)" placeholder="请输入合同回款总金额" @input="getSum" label-width="145px" type="number" maxlength="15" :rules="[{ required: true }]" required />
          <van-field v-model="form.noReturnedMoney" label="合同未回款金额(元)"  placeholder="未回款金额=合同金额-合同回款总金额" disabled label-width="145px" type="number" maxlength="15" :rules="[{ required: true }]"  />
          <van-field readonly clickable v-model="form.contractTypeName" @click="showPicker('contractType')" label="合同类型" placeholder="请选择合同类型" required />
          <van-field readonly clickable v-model="form.contractStatusName" placeholder="请选择合同状态" @click="showPicker('contractStatus')" label="合同状态" />
          <van-field readonly clickable v-model="form.payModeName" placeholder="请选择支付方式" @click="showPicker('payMode')" label="支付方式" required />
          <van-field v-model="form.startTime" readonly clickable name="calendar" label="开始时间" placeholder="点击选择日期" @click="showStartCalendar = true" required />
          <van-field v-model="form.endTime" readonly clickable name="calendar" label="结束时间" placeholder="点击选择日期" @click="showEndCalendar = true" required />
          <van-field v-model="form.signTime" readonly clickable name="calendar" label="签约日期" placeholder="点击选择日期" @click="showSignCalendar = true" required />
          <van-field v-model="form.custSignedUser" label="对方签约人" placeholder="请填写对方签约人" :rules="[{ required: true }]" required />
          <van-field v-model="form.signedUserMobile" label="对方电话" placeholder="请填写对方电话" maxlength="11" :rules="mobileRules" required  />

          <van-field readonly v-model="form.deptName" label="部门"  placeholder="请选择所在部门"   @click="showDeptTree = true" required  />
          <van-field readonly v-model="form.mySignedUser" label="我方签约人" placeholder="请填写我方签约人" @click="showPicker('sysUser')" :rules="[{ required: true}]" required />
          <!-- <van-field name="rate" label="电子合同">
            <template #input>
              <van-uploader v-model="fileList" :after-read="uploadContractFiles" :max-count="1" :max-size="52428800" upload-text="电子合同" required>
              </van-uploader>
            </template>
          </van-field>
          <van-field name="rate" label="附件1">
            <template #input>
              <van-uploader v-model="fileList1" :after-read="uploadContractFiles1" :max-count="1" :max-size="52428800" upload-text="附件1">
              </van-uploader>
            </template>
          </van-field>
          <van-field name="rate" label="附件2">
            <template #input>
              <van-uploader v-model="fileList2" :after-read="uploadContractFiles2" :max-count="1" :max-size="52428800" upload-text="附件2">
              </van-uploader>
            </template>
          </van-field> -->
          <van-field v-model="form.remark" label="备注" />
          <van-field v-model="form.content" rows="2" type="textarea" label="合同内容" />
        </van-cell-group>
      </van-form>
    </van-dialog>
    <!-- 日期选择器 -->
    <van-calendar v-model="showStartCalendar" :min-date="minDate" type="single" @confirm="onStartCalendarConfirm" />
    <van-calendar v-model="showEndCalendar" :min-date="minDateStart" type="single" @confirm="onEndCalendarConfirm" />
    <van-calendar v-model="showSignCalendar" :min-date="minDate" type="single" @confirm="onSignCalendarConfirm" />
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>

    <van-popup v-model="showDeptTree" position="bottom">
      <van-cascader title="请选择部门" :options="deptTreeList" @change="deptChange"  @close="showDeptTree = false" @finish="onFinishDeptTree" />
    </van-popup>
  </div>
</template>
<script>
import { ucloudUpFileToContract } from "@/api/system/common"; 
import { Toast,Dialog,Cascader } from "vant"
import {listBo} from "@/api/scrm/mycust";
import {selectDeptIdByUserList} from "@/api/admi/user"


export default {
  name: 'DialogContract',
  components: {
     vanCascader: Cascader,
  },
  props: {
    show: Boolean,
    contractType: Number,
    deptTreeOptions:Array
  },
  watch: {
    show: {
      handler(val, oldVal) {
        this.DialogShow = val
      }
    },
    contractType: {
      handler(val, oldVal) {
        this.form.contractType = val
      }
    },
    deptTreeOptions:{
      handler(val, oldVal) {
        this.deptTreeList = val
       // console.log("val:"+JSON.stringify(val));
      }
    }
  },
  data() {
    return {
      DialogShow: this.show,
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
      },
      deptTreeList: [],
      //商机数据
      custBoList:[],
      //部门人员数据
      deptUserList:[],
      queryBoParams: {
      },
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [],
      fileList: [],
      total: 0,
      fileList1: [],
      fileList2: [],
      //选择部门弹出框
      showDeptTree:false,
      cascaderValue:'', 
    //   options : [
    //   {
    //     text: '浙江省',
    //     value: '330000',
    //     children: [{ text: '杭州市', value: '330100' }],
    //   },
    //   {
    //     text: '江苏省',
    //     value: '320000',
    //     children: [{ text: '南京市', value: '320100',
    //      children: [{ text: '222', value: '330100',
    //       children: [{ text: '444', value: '330100' }] }]
    //     }],
    //   },
    // ],
      form: {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: this.contractType,
        contractStatus: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      }, 
      mobileRules:
      [{
          required: true,
          message: '手机号码不能为空',
          trigger: 'onBlur'
      },
        {
        // 自定义校验规则
          validator: value => {
              return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
                  .test(value)
          },
          message: '请输入正确格式的手机号码',
          trigger: 'onBlur'
      }],
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
    }
  }, 
  methods: { 
    deptChange(obj){ 
      this.form.deptId = obj.value;
      this.form.deptName = obj.selectedOptions.map((option) => option.text).join("/");
      console.log(this.form.deptName);
    },
    /** 转换产品类型数据结构 */
    deptNormalizer(node) { 
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            value: node.children[i].id,
            text: node.children[i].label
          }
          arr.push(item)
        }
      }
      return {
        value: node.id,
        text: node.label,
        children: arr
      };
    },
    onFinishDeptTree(obj){
        this.showDeptTree = false;
        // this.form.deptId = obj.value;
        // this.form.deptName = obj.selectedOptions.map((option) => option.text).join("/");
    },
    getSum(){
      let contractMoeny = this.form.contractMoney || 0;
      let allReturnedMoney = this.form.allReturnedMoney || 0; 
      let total = contractMoeny - allReturnedMoney
      this.form.noReturnedMoney = total.toFixed(2);
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + "-" + month + "-" + day;
    },
    onStartCalendarConfirm(data) {
      this.form.startTime = this.formatDate(data);
      this.showStartCalendar = false;
      this.minDateStart = data
    },
    onEndCalendarConfirm(data) {
      this.form.endTime = this.formatDate(data);
      this.showEndCalendar = false;
    },
    onSignCalendarConfirm(data) {
      this.form.signTime = this.formatDate(data);
      this.showSignCalendar = false;
    },
    async beforeClose(type, done) {
      if (type === "confirm") { 
        try {
          if(this.form.allReturnedMoney && this.form.contractMoney && 
            parseFloat(this.form.allReturnedMoney) > parseFloat(this.form.contractMoney)){
            Toast.fail("合同回款金额不能大于合同金额！");
            return done(false);
          }
          // if(new Date(this.form.signTime) < new Date(this.form.startTime)){
          //   Toast.fail("签约时间不能小于合同开始时间！");
          //   return done(false);
          // }  
          await this.$refs["form"].validate();
          this.$emit('beforeClose', this.form)
          .then(() => { 
            Toast.success("添加成功"); 
          }).catch(()=>{}); 
          done();
        } catch (err) {
          return done(false);
        }
        return done(false);
      }else{
          done();
          this.$emit('handleAddContractCancel')
      } 
    },
    showPicker(type) {
      this.picker.formKey = type;
      if (type === "contractType") {
        this.picker.columns = this.contractTypeOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "contractStatus") {
        this.picker.columns = this.contractStatusOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "payMode") {
        this.picker.columns = this.payModeOptions.map((ele) => ele.dictLabel);
      }
      //选择商机
      if(type === "boId"){  
        listBo(this.queryBoParams).then(response => {
          this.custBoList = response.rows; 
          this.picker.columns = this.custBoList.map(item => item.boName + "(" + item.custName + ")");
        }); 
      }
      //选择人员
      if(type === "sysUser"){
        selectDeptIdByUserList(this.form.deptId).then(response => {
          this.deptUserList = response.data; 
          this.picker.columns = this.deptUserList.map(item => item.nickName );
        }); 
      }

      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "contractType") {
        this.form.contractType = this.contractTypeOptions[index].dictValue;
        this.form.contractTypeName = this.contractTypeOptions[index].dictLabel;
      }
      if (this.picker.formKey === "contractStatus") {
        this.form.contractStatus = this.contractStatusOptions[index].dictValue;
        this.form.contractStatusName =
          this.contractStatusOptions[index].dictLabel;
      }
      if (this.picker.formKey === "payMode") {
        this.form.payMode = this.payModeOptions[index].dictValue;
        this.form.payModeName = this.payModeOptions[index].dictLabel;
      }
      //选择商机
      if (this.picker.formKey === "boId"){  
        this.form.boId = this.custBoList[index].boId;
        this.form.boName = this.custBoList[index].boName;
        this.form.custId = this.custBoList[index].custId;
        this.form.custName = this.custBoList[index].custName;
      }
      //选择人员
      if (this.picker.formKey === "sysUser"){  
        this.form.mySignedUser = this.deptUserList[index].nickName;
      }
      this.picker.visible = false;
    },

    pickerCancel() {
      this.picker.visible = false;
    },
    uploadContractFiles(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.contractFile = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles1(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.annexOne = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles2(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.annexTwo = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },

}
</script>
<style lang="less" scoped>
.editClue /deep/.van-dialog__content {
  height: 80%;
}
</style>